import { create } from 'zustand';
import { MicBlockedStoreType } from '../types/store/mic-blocked.types';

export const useMicBlockedStore = create<MicBlockedStoreType>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
